/**
 * Fornada Validation Schemas
 */

import { z } from "zod";

export const fornadaItemSchema = z.object({
  id_receita: z.string().uuid("ID da receita inválido"),
  receita_nome: z.string().min(1, "Nome da receita é obrigatório"),
  quantidade_produzida: z.number()
    .min(0.001, "Quantidade deve ser maior que zero")
    .max(999999, "Quantidade muito alta"),
  custo_unitario_fixado: z.number()
    .min(0, "Custo unitário não pode ser negativo"),
  custo_total_item: z.number()
    .min(0, "Custo total não pode ser negativo"),
  receita_rendimento: z.number().optional().nullable(),
  receita_custo_total: z.number().min(0, "Custo da receita inválido"),
  observacoes_item: z.string().max(500, "Observações devem ter no máximo 500 caracteres").optional().nullable(),
});

export const fornadaCustoAdicionalSchema = z.object({
  tipo_produto_id: z.string().optional().nullable(),
  descricao: z.string().min(1, "Descrição é obrigatória").max(200, "Descrição muito longa"),
  quantidade: z.number()
    .min(0.001, "Quantidade deve ser maior que zero")
    .max(999999, "Quantidade muito alta"),
  valor_unitario: z.number()
    .min(0, "Valor unitário não pode ser negativo")
    .max(999999, "Valor muito alto"),
  valor_total: z.number()
    .min(0, "Valor total não pode ser negativo"),
});

export const fornadaSchema = z.object({
  data_fornada: z.string().min(1, "Data da fornada é obrigatória"),
  responsavel: z.string().max(200, "Nome muito longo").optional().nullable(),
  destino: z.enum(['vitrine', 'encomenda', 'teste', 'outro']).optional().nullable(),
  observacoes_gerais: z.string().max(1000, "Observações devem ter no máximo 1000 caracteres").optional().nullable(),
  
  // Campos manuais
  rendimento_total: z.number()
    .min(0, "Rendimento não pode ser negativo")
    .max(999999, "Rendimento muito alto")
    .optional()
    .nullable(),
  tempo_total_minutos: z.number()
    .int("Tempo deve ser um número inteiro")
    .min(0, "Tempo não pode ser negativo")
    .max(10080, "Tempo muito alto (máx: 1 semana)")
    .optional()
    .nullable(),
  
  // Custos Operacionais
  valor_hora_profissional: z.number()
    .min(0, "Valor/hora não pode ser negativo")
    .max(999999, "Valor muito alto")
    .optional()
    .nullable(),
  custo_mao_obra: z.number()
    .min(0, "Custo não pode ser negativo")
    .optional()
    .nullable(),
  custo_gas: z.number()
    .min(0, "Custo não pode ser negativo")
    .optional()
    .nullable(),
  tipo_gas: z.enum(['GLP', 'GNV']).optional().nullable(),
  outras_despesas: z.number()
    .min(0, "Valor não pode ser negativo")
    .optional()
    .nullable(),
  
  debitar_estoque: z.boolean().default(true),
  
  // Itens (validação de pelo menos 1 item)
  itens: z.array(fornadaItemSchema)
    .min(1, "Adicione pelo menos uma receita à fornada"),
  
  // Custos adicionais (opcional)
  custos_adicionais: z.array(fornadaCustoAdicionalSchema).optional(),
});

export type FornadaFormData = z.infer<typeof fornadaSchema>;
export type FornadaItemFormData = z.infer<typeof fornadaItemSchema>;
export type FornadaCustoAdicionalFormData = z.infer<typeof fornadaCustoAdicionalSchema>;
